<template>
  <div class="w1200">
    <div class="bg" style="padding-top: 0">
      <div class="treeTop">
        <div
          v-for="(section, i) in sectionData"
          :key="'section' + i"
          :class="activeName == section.id ? 'on' : ''"
          :style="'width: calc(268px/' + sectionData.length + ');'"
        >
          <span @click="activeName = section.id">{{ section.label }}</span>
          <ul>
            <li
              v-for="(subject, j) in section.children"
              :key="'subject_' + i + '_' + j"
              :class="subject.show ? 'on' : ''"
            >
              <span @click="goResource(section, subject)"
                >{{ subject.label }}
                <i class="el-icon-arrow-right fr"></i>
              </span>
              <!-- <div v-if="subject.children && subject.children.length > 0">
                <span
                  v-for="(s, k) in subject.children"
                  :key="'subject' + k"
                  @click="goResource(section, subject, s)"
                  >{{ s.label }}</span
                >
              </div> -->
            </li>
          </ul>
        </div>
      </div>
      <div class="navIndex">
        <ul>
          <li class="on">
            <router-link to="/">首页</router-link>
          </li>
          <li><router-link to="/resource">资源中心</router-link></li>
          <!-- <li><router-link to="">题库组卷</router-link></li> -->
          <li><router-link to="/special">专题资源</router-link></li>
          <li><router-link to="/classroom">三师课堂</router-link></li>
          <li><router-link to="/statistics">统计中心</router-link></li>
          <li>
            <a :href="configure.helpUrl" target="_blank">帮助中心</a>
          </li>
        </ul>
      </div>
      <div class="banner fl">
        <div class="top">
          <el-carousel
            height="290px"
            :interval="4000"
            v-if="banner1.length > 0"
          >
            <el-carousel-item v-for="(item, i) in banner1" :key="'banner1' + i">
              <a :href="item.linkUrl">
                <el-image
                  :src="uploadUrl + item.imageUrl"
                  style="width: 600px; height: 290px"
                ></el-image
              ></a>
            </el-carousel-item>
          </el-carousel>
          <div v-else class="unusual1"></div>
        </div>
        <div class="bottom">
          <template v-if="banner2.length > 0">
            <ul
              :style="'left:' + banner2_id * -205 + 'px'"
              @mouseenter="rollStop()"
              @mouseleave="rollStart()"
              v-if="banner2.length > 0"
            >
              <li v-for="(item, i) in banner2" :key="'banner_2_' + i">
                <a :href="item.linkUrl">
                  <el-image
                    :src="uploadUrl + item.imageUrl"
                    style="width: 190px; height: 110px"
                  ></el-image
                ></a>
              </li>
            </ul>
            <span class="lt" @click="rollGoLeft"
              ><i class="el-icon-arrow-left"></i
            ></span>
            <span class="gt" @click="rollGoRight"
              ><i class="el-icon-arrow-right"></i></span
          ></template>
          <div
            v-else
            style="display: flex; height: 110px; justify-content: space-between"
          >
            <div class="unusual1" style="width: 190px"></div>
            <div class="unusual1" style="width: 190px"></div>
            <div class="unusual1" style="width: 190px"></div>
          </div>
        </div>
      </div>
      <div class="zytj fl">
        <div class="hd ys1"><span>资源统计</span></div>
        <div class="bd">
          <ul>
            <li>
              <span>资源总量（套）</span><em>{{ statistic.resourceCount }}</em>
            </li>
            <li>
              <span>资源容量（{{ statistic.unit }}）</span
              ><em>{{ statistic.resourceSizeCount }}</em>
            </li>
            <li>
              <span>当月新增（套）</span
              ><em>{{ statistic.resourceCurrentMonthCount }}</em>
            </li>
            <li>
              <span>本学期增加（套）</span
              ><em>{{ statistic.resourceCurrentTermCount }}</em>
            </li>
            <li>
              <span>本周新增（套）</span
              ><em>{{ statistic.resourceCurrentWeekCount }}</em>
            </li>
            <li>
              <span>上周增加（套）</span
              ><em>{{ statistic.resourceLastWeekCount }}</em>
            </li>
          </ul>
        </div>
      </div>
      <div class="ssgxgk fl">
        <div class="hd ys1"><span>实时共享概况</span></div>
        <div class="bd">
          <div
            class="roll"
            :style="'top:' + roll * -1 + 'px'"
            @mouseenter="rollState = false"
            @mouseleave="rollState = true"
          >
            <ul>
              <li v-for="(item, i) in shareData" :key="'share' + i">
                <span
                  class="whiteSpace"
                  @click="yulan(item, 1)"
                  :title="
                    item.schoolName +
                    item.createUserName +
                    '共享了' +
                    item.fileTypeName +
                    item.resourceName
                  "
                  >{{ item.schoolName + item.createUserName }}共享了{{
                    item.fileTypeName + item.resourceName
                  }}</span
                >
              </li>
              <li v-for="(item, i) in shareData" :key="'share_2_' + i">
                <span
                  class="whiteSpace"
                  @click="yulan(item, 1)"
                  :title="
                    item.schoolName +
                    item.createUserName +
                    '共享了' +
                    item.fileTypeName +
                    item.resourceName
                  "
                  >{{ item.schoolName + item.createUserName }}共享了{{
                    item.fileTypeName + item.resourceName
                  }}</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bg">
      <div class="hd ys2">
        <h3>最新资源</h3>
        <el-select
          v-model="newest.section"
          size="small"
          placeholder="请选择"
          @change="getNew"
        >
          <el-option
            v-for="(item, i) in sectionData"
            :key="'zxxk' + i"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span
          class="tabs"
          @click="
            newest.id = '';
            getNew();
          "
          :class="newest.id == '' ? 'on' : ''"
          >全部</span
        >
        <el-tabs v-model="newest.id" @tab-click="getNew">
          <el-tab-pane
            v-for="(item, i) in sectionData.filter(
              (el) => el.id == newest.section
            ).length > 0
              ? sectionData.filter((el) => el.id == newest.section)[0].children
              : []"
            :key="'newestSection' + i"
            :label="item.label"
            :name="item.id"
          ></el-tab-pane>
        </el-tabs>
        <span class="more" @click="goResource1(newest)">更多</span>
      </div>
      <div class="bd ys2" style="height: 220px">
        <ul v-if="newest.data.length > 0">
          <li v-for="(n, i) in newest.data" :key="'newestData' + i">
            <svg class="icon" aria-hidden="true" slot="reference" width="30">
              <use :xlink:href="'#icontbx' + n.fileType"></use></svg
            ><a @click="yulan(n, 1)" target="_blank">{{ n.resourceName }}</a>
            <span class="time">{{n.createTime.split(" ")[0].substring(5, 10)}}</span>
          </li>
        </ul>
        <div class="unusual" v-else><span class="pt160">暂无内容</span></div>
      </div>
    </div>
    <div class="banner3">
      <el-carousel
        height="140px"
        direction="vertical"
        :autoplay="false"
        ref="banner3"
        v-if="banner3.length > 0"
      >
        <el-carousel-item v-for="(item, i) in banner3" :key="'banner3' + i">
          <a :href="item.linkUrl">
            <el-image
              :src="uploadUrl + item.imageUrl"
              style="height: 140px; width: 1200px"
            ></el-image
          ></a>
        </el-carousel-item>
      </el-carousel>
      <div class="unusual" v-else><span class="pt160">暂无内容</span></div>
      <!-- <i class="el-icon-arrow-left" @click="a"></i>
      <i class="el-icon-arrow-right"></i> -->
    </div>
    <div class="bg">
      <div class="hd ys2">
        <h3>热门资源</h3>
        <el-select
          v-model="newest1.section"
          size="small"
          placeholder="请选择"
          @change="getHot"
        >
          <el-option
            v-for="(item, i) in sectionData"
            :key="'zxxk' + i"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span
          class="tabs"
          @click="
            newest1.id = '';
            getHot();
          "
          :class="newest1.id == '' ? 'on' : ''"
          >全部</span
        >
        <el-tabs v-model="newest1.id" @tab-click="getHot">
          <el-tab-pane
            v-for="(item, i) in sectionData.filter(
              (el) => el.id == newest1.section
            ).length > 0
              ? sectionData.filter((el) => el.id == newest1.section)[0].children
              : []"
            :key="'newestSection_1' + i"
            :label="item.label"
            :name="item.id"
          ></el-tab-pane>
        </el-tabs>
        <span class="more" @click="goResource1(newest1, '下载量')">更多</span>
      </div>
      <div class="bd ys2" style="height: 220px">
        <ul v-if="newest1.data.length > 0">
          <li v-for="(n, i) in newest1.data" :key="'newestData' + i">
            <svg class="icon" aria-hidden="true" slot="reference" width="30">
              <use :xlink:href="'#icontbx' + n.fileType"></use></svg
            ><a @click="yulan(n, 1)" target="_blank">{{ n.resourceName }}</a>
            <span class="time">{{
              n.createTime.split(" ")[0].substring(5, 10)
            }}</span>
          </li>
        </ul>
        <div class="unusual" v-else><span class="pt160">暂无内容</span></div>
      </div>
    </div>
    <div class="bg">
      <div class="hd ys2">
        <h3>专题资源</h3>
        <span class="more" @click="$router.push({ name: 'special' })"
          >更多</span
        >
      </div>
      <div class="bd ys3" style="height: 520px">
        <ul v-if="special.length > 0">
          <li v-for="(n, i) in special" :key="'newestData' + i">
            <div
              class="cup"
              @click="
                $router.push({ path: '/special/details', query: { id: n.id } })
              "
            >
              <el-image
                style="width: 100%; height: 150px"
                :src="uploadUrl + n.typeImage"
              ></el-image
              ><span>{{ n.typeName }}</span>
            </div>
            <dl>
              <dd>
                <i class="el-icon-view"></i><em>{{ n.visitedSum }}次</em>
              </dd>
              <dd>
                <i class="el-icon-download"></i><em>{{ n.downloadSum }}次</em>
              </dd>
            </dl>
          </li>
        </ul>
        <div class="unusual" v-else><span class="pt320">暂无内容</span></div>
      </div>
    </div>
    <div class="bg">
      <div class="hd ys2">
        <h3>贡献榜</h3>
        <!-- <span class="more">更多</span> -->
      </div>
      <div class="bd ranking">
        <div class="w50 schoolRanking">
          <div class="hd">
            <i class="el-icon-star-on"></i>
            <h3>学校贡献榜</h3>
          </div>
          <div class="bd">
            <div class="medal">
              <div
                v-for="(s, i) in schoolRanking.slice(0, 3)"
                :key="'peopleRankingJ' + i"
              >
                {{ s.orgName }}
              </div>
            </div>
            <ul>
              <li>
                <div class="rank">排名</div>
                <div class="title">学校名称</div>
                <div class="sun">共享资源数</div>
              </li>
              <li v-for="(s, i) in schoolRanking" :key="'schoolRanking' + i">
                <div class="rank">{{ i + 1 }}</div>
                <div class="title">{{ s.orgName }}</div>
                <div class="sun">{{ s.resourceCount }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w50 peopleRanking">
          <div class="hd">
            <i class="el-icon-star-on"></i>
            <h3>个人贡献榜</h3>
          </div>
          <div class="bd">
            <div class="medal">
              <div
                v-for="(s, i) in peopleRanking.slice(0, 3)"
                :key="'peopleRankingJ' + i"
              >
                {{ s.userName }}
              </div>
            </div>
            <ul>
              <li>
                <div class="rank">排名</div>
                <div class="author">作者</div>
                <div class="school">学校名称</div>
                <div class="sun">共享资源总数</div>
              </li>
              <li v-for="(s, i) in peopleRanking" :key="'peopleRanking' + i">
                <div class="rank">{{ i + 1 }}</div>
                <div class="author">{{ s.userName }}</div>
                <div class="school">{{ s.orgName }}</div>
                <div class="sun">{{ s.resourceCount }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import role from "../mixins/role";
import yulan from "../mixins/yulan";
export default {
  name: "index",
  componentName: "index",
  data() {
    return {
      // 学段-学科-版本
      activeName: "",
      sectionData: [],
      // banner图数据
      statistic: {
        resourceCount: 0,
        resourceCurrentMonthCount: 0,
        resourceCurrentTermCount: 0,
        resourceCurrentWeekCount: 0,
        resourceLastWeekCount: 0,
        resourceSizeCount: 0,
      },
      banner1: [],
      banner2: [],
      // 第二张banner图滚动
      interval: "",
      banner2_id: 0,
      banner2_time: 1,
      // 统计
      shareData: [],
      // 共享概况
      roll: 0,
      rollState: true,
      rollSpeed: 3,
      newest: {
        section: "",
        id: "",
        data: [],
      },
      newest1: {
        section: "",
        id: "",
        data: [],
      },
      banner3: [],
      special: [],
      schoolRanking: [],
      peopleRanking: [],
      uploadUrl: "",
    };
  },
  computed: {
    currentdirectory: function () {
      return this.$attrs.currentdirectory;
    },
    ...mapState(["userModule"]),
    ...mapState(["configure"]),
  },
  mixins: [role, yulan],
  watch: {
    currentdirectory: function (val) {
      if (val && !this.newest1.section) {
        this.newest1.section = val.sectionId;
        this.newest1.id = val.subjectId;
        this.getHot();
      }
      if (val && !this.newest.section) {
        this.newest.section = val.sectionId;
        this.newest.id = val.subjectId;
        this.getNew();
      }
    },
  },
  methods: {
    getHot() {
      this.$ajax
        .post("/server/index/load/hot/resource", {
          size: 12,
          page: 1,
          sectionId: this.newest1.section,
          subjectId: this.newest1.id,
        })
        .then((res) => {
          this.newest1.data = res;
        });
    },
    getNew() {
      this.$ajax
        .post("/server/index/load/new/resource", {
          size: 12,
          page: 1,
          sectionId: this.newest.section,
          subjectId: this.newest.id,
        })
        .then((res) => {
          this.newest.data = res;
        });
    },
    goResource1(newest, c = "最新") {
      debugger;
      let a = this.sectionData.filter((el) => el.id == newest.section)[0];
      if (a.children.length == 0) {
        this.$message("没有相应学科");
        return false;
      }
      let b = newest.id
        ? a.children.filter((el) => el.id == newest.id)[0]
        : a.children[0];
      this.$router.push({
        name: "resource",
        params: {
          sortOrder: c,
          sectionId: newest.section,
          subjectId: newest.id,
          sectionName: a.label,
          subjectName: b.label,
        },
      });
    },
    goResource(i, j, k) {
      window.sessionStorage.setItem(
        "currentDirectory",
        JSON.stringify({
          sectionId: i.id,
          sectionName: i.label,
          subjectId: j.id,
          subjectName: j.label,
          versionId: k === undefined ? "" : k.id,
          versionName: k === undefined ? "" : k.label,
          gradeId: "",
          volumeId: "",
          relationDataId: "",
          chapterId: "",
        })
      );
      let b = ["资源平台", i.label + j.label];
      if (k != undefined) {
        b.push(k.label);
      }
      window.sessionStorage.setItem("breadcrumb", JSON.stringify(b));
      this.$router.push({ name: "resource" });
    },
    loadSon(i, j) {
      if (!this.sectionData[i].children[j].son) {
        this.$ajax
          .post("/common/catalog/load/version", {
            sectionId: this.sectionData[i].id,
            subjectId: this.sectionData[i].children[j].id,
          })
          .then((res) => {
            this.sectionData[i].children[j].children = res;
            this.sectionData[i].children[j].son = true;
            window.sessionStorage.setItem(
              "sectionData",
              JSON.stringify(this.sectionData)
            );
          });
      }
    },
    init() {
      this.sectionData = JSON.parse(
        window.sessionStorage.getItem("sectionData")
      );
      this.activeName = JSON.parse(
        window.sessionStorage.getItem("currentDirectory")
      ).sectionId;
      this.uploadUrl = window.sessionStorage.getItem("uploadUrl");

      this.$ajax.post("/server/index/load/resource/statistic").then((res) => {
        this.statistic = res;
        if (!this.statistic.resourceSizeCount) {
          this.statistic.resourceSizeCount = 0;
        }
        let arr = ["B", "KB", "MB", "GB", "TB"];
        let i = 0;
        while (this.statistic.resourceSizeCount > 1024) {
          i++;
          this.statistic.resourceSizeCount =
            Math.floor((this.statistic.resourceSizeCount * 100) / 1024) / 100;
        }
        this.statistic.unit = arr[i];
      });

      this.$ajax
        .post("/server/index/load/thematic/type", { top: 8 })
        .then((res) => {
          this.special = res?res:[];
          this.special.forEach((el) => {
            if (!el.typeImage) {
              el.typeImage = "";
            }
            if (!el.downloadSum) {
              el.downloadSum = 0;
            }
            if (!el.visitedSum) {
              el.visitedSum = 0;
            }
          });
        });

      this.$ajax
        .post("/server/index/load/school/contribution", { top: 8 })
        .then((res) => {
          this.schoolRanking = res?res:[];
        });

      this.$ajax
        .post("/server/index/load/user/contribution", { top: 8 })
        .then((res) => {
          this.peopleRanking = res?res:[];
        });
      // 实时
      this.$ajax
        .post(
          "/server/index/load/realTime/share",
          { size: 10, page: 1 },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.shareData = res;
        });

      this.$ajax
        .post("/server/index/load/pictures", {
          imageType: 1,
          page: 1,
          size: 5,
        })
        .then((res) => {
          this.banner1 = res.list;
        });

      this.$ajax
        .post("/server/index/load/pictures", {
          imageType: 2,
          page: 1,
          size: 5,
        })
        .then((res) => {
          this.banner2 = res.list;
        });

      this.$ajax
        .post("/server/index/load/pictures", {
          imageType: 3,
          page: 1,
          size: 5,
        })
        .then((res) => {
          this.banner3 = res.list;
        });
      this.rollStart();
      this.rollFun();
    },
    // a() {
    //   this.$refs.banner3.prev();
    // },
    rollFun() {
      setInterval(() => {
        if (this.rollState) {
          if (this.roll >= this.shareData.length * 27) {
            this.roll = 0;
          }
          this.roll++;
        }
      }, 100 - this.rollSpeed * 10);
    },
    bannerRollFun(v = true) {
      if (this.banner2) {
        if (v) {
          if (this.banner2_id < this.banner2.length - 3) {
            this.banner2_id++;
          } else {
            this.banner2_id = 0;
          }
        } else {
          if (this.banner2_id > 0) {
            this.banner2_id--;
          } else {
            this.banner2_id = this.banner2.length - 3;
          }
        }
      }
    },
    rollStart() {
      this.interval = setInterval(this.bannerRollFun, 1000 * this.banner2_time);
    },
    rollStop() {
      clearInterval(this.interval);
    },
    rollGoLeft() {
      this.rollStop();
      this.bannerRollFun(false);
      this.rollStart();
    },
    rollGoRight() {
      this.rollStop();
      this.bannerRollFun();
      this.rollStart();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/IndexPage.vue